import Box from "@mui/material/Box";
import * as React from "react";
import { useDispatch } from "react-redux";
import { CapacitiesRow, DriversRow } from "../../api";
import { DriverPulldown } from "../../components/driverPulldown";
import { OfficePullDown } from "../../components/officePullDown";
import * as Service from "../../services/usage_based_capacity/select";
import { commonSlice, commonState } from "../../store";
import { fontSizes } from "../../theme";
import { State } from "./store";

import {
    LoadingTableElement,
    NullTableElement,
} from "../../components/table/nullTable";
import {
    SortableTable,
    newDisplayCond,
} from "../../components/table/sortableTable";
import { headCells } from "./columns_capacity";

interface Props {
    common: commonState;
    state: State;
}

const convertCapacityToTableData = (capacityList?: CapacitiesRow[]) => {
    if (!capacityList) {
        return null;
    }

    const data = capacityList.map((rec: CapacitiesRow) => {
        return {
            officeName: rec.officeName,
            driverName: rec.driverName,
            startedDate: rec.startedDate,
            capPrice: rec.capPrice,
            capTrips: rec.capTrips,
            driverId: rec.driverId,
            officeId: rec.officeId,
            row_id: `${rec.officeId}_${rec.driverId}`,
        };
    });
    return data;
};

export const CapacityTable: React.FC<Props> = (props: Props) => {
    const dispatch = useDispatch();

    const selectOffice = async (officeId: number) => {
        await dispatch(commonSlice.actions.updateSelectedOffice(officeId));
        Service.selectCapacities();
    };

    const selectDriver = async (driver: DriversRow) => {
        await dispatch(commonSlice.actions.updateSelectedDriver(driver));
        Service.selectCapacities();
    };

    const clearDriver = async () => {
        await dispatch(commonSlice.actions.updateSelectedDriver(null));
        Service.selectCapacities();
    };

    const handleRowClick = () => {};

    const _data = convertCapacityToTableData(props.state.capacities);

    let tableElement = <LoadingTableElement />;

    if (_data) {
        if (props.state.capacities) {
            if (props.state.capacities.length == 0) {
                tableElement = <NullTableElement />;
            } else {
                tableElement = (
                    <SortableTable
                        tableHeaders={headCells}
                        tableData={_data}
                        tableProps={props}
                        displayCond={newDisplayCond("officeName", "asc", 0, 20)}
                        rowIdField={"row_id"}
                        onRowClickMethod={handleRowClick}
                        slimRows={true}
                    />
                );
            }
        }
    }

    return (
        <>
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                    id="capacity-office-selector"
                    sx={{ display: "flex", alignItems: "center" }}
                >
                    <Box sx={{ fontSize: fontSizes.large }}> 営業所 </Box>
                    <Box sx={{ m: 4 }}>
                        <OfficePullDown
                            selectedOfficeId={props.common.selectedOfficeId}
                            onChange={selectOffice}
                            useAllOfficeIds={true}
                        />
                    </Box>
                </Box>
                <Box id="capacity-driver-selector">
                    <DriverPulldown
                        selectedDriver={props.common.selectedDriver}
                        driverCompleteData={props.common.driverNames}
                        onChange={selectDriver}
                        onClear={clearDriver}
                        initWithNull={false}
                    ></DriverPulldown>
                </Box>
            </Box>
            <Box
                id="capacity-table-container"
                sx={{
                    minHeight: "1200px",
                }}
            >
                {tableElement}
                {/* {_data ? (
                    <SortableTable
                        tableHeaders={headCells}
                        tableData={_data}
                        tableProps={props}
                        initialSortColumn={"officeName"}
                        initialSortDirection={"asc"}
                        rowIdField={"row_id"}
                        onRowClickMethod={handleRowClick}
                        slimRows={true}
                    />
                ) : (
                    <NullTableElement />
                )} */}
            </Box>
        </>
    );
};

export const CapacityContainer: React.FC<Props> = (props: Props) => {
    React.useEffect(() => {
        // 表示時イベント
        Service.selectCapacities();
    }, []);

    return (
        <Box>
            <CapacityTable common={props.common} state={props.state} />
        </Box>
    );
};
